<template>
  <div
    v-show="visible"
    ref="wrapper"
    :class="['edit', isFocus ? 'z-10' : '']"
    :style="style"
    @click="$emit('clickNote')"
  >
    <div
      ref="title"
      class="title w-full flex justify-between items-center pl-5 pr-6 py-2 relative cursor-move"
    >
      <div class="flex w-11/12 items-center justify-start">
        <img class="inline-block note-icon" src="../assets/note.png" alt="笔记" />
        <span class="font-semibold text-lg title-text ml-1 truncate">{{
          (learningNotes && learningNotes.length && learningNotes[0].selectValue) || '笔记'
        }}</span>
      </div>
      <div
        class="close w-4 h-4 cursor-pointer flex items-center justify-center ml-1"
        @click="close"
      >
        <img src="../assets/close.svg" alt="关闭" />
      </div>
    </div>
    <div class="w-full p-6 overflow-y-auto">
      <div v-for="(item, index) in learningNotes" :key="index" class="md-6 notes">
        <div class="note-title flex justify-between select-none">
          <div class="whitespace-normal break-all">{{ item.noteTitle }}</div>
          <div class="opacity-100 md:opacity-0 del">
            <img
              class="inline-block cursor-pointer"
              src="../assets/delete.svg"
              alt="删除"
              @click="handelDeleteModel(item.id)"
            />
          </div>
        </div>
        <div class="note-content whitespace-normal break-all">{{ item.noteContent }}</div>
      </div>
    </div>
    <DeleteModel ref="delete" @delete="handelDelete" />
  </div>
</template>
<script lang="ts">
import { Content } from '@forchange/storytime';
import { Component, Prop, Mixins } from 'vue-property-decorator';
import Position from '../mixins/position';
import QUERY_NOTE from '../graphql/queryNote';
import DELETE_NOTE from '../graphql/deleteNote';
import DeleteModel from './Delete.vue';
@Component({
  components: {
    DeleteModel
  }
})
export default class NoteEdit extends Mixins(Position) {
  @Prop({ type: Object }) content: Content & {
    noteIds: any;
  };
  @Prop({ type: Boolean }) isFocus: boolean;
  @Prop({ type: Number }) utteranceIndex: number;
  @Prop({ type: Object }) environment: {
    sharedKey?: string;
  };

  visible = false;

  learningNotes: Array<{
    id: string;
    noteTitle: string;
    noteContent: string;
    selectValue: string;
  }> = [];

  get style() {
    return {
      top: (this.position.top || 0) + 'px',
      left: (this.position.left || 0) + 'px'
    };
  }

  mounted() {
    // 拖拽事件注册
    this.bindEvents();
  }

  open() {
    this.$nextTick(() => {
      this.initPosition();
    });
    this.visible = true;
    this.getContent();
  }
  async getContent() {
    const noteIds = this.content.noteIds?.[this.utteranceIndex];
    if (!noteIds) return;
    const noteContents = await this.$getClemanClient().apollo.mutate({
      mutation: QUERY_NOTE,
      variables: {
        ids: noteIds
      }
    });

    this.learningNotes = noteContents.data.courseLearningNotes;
    if (!this.learningNotes.length) this.close();
  }

  close() {
    this.visible = false;
  }

  handelDeleteModel(id: string) {
    this.$Modal.confirm({
      type: 'wran',
      title: '删除笔记',
      descript: '确定删除该笔记吗？笔记删除之后将无法恢复！',
      onOk: () => this.handelDelete(id)
    });
  }

  async handelDelete(id: string) {
    try {
      await this.$store.dispatch('note/deleteNote', id);
      this.$store.dispatch('note/resetList');
      const noteIds: Array<string> = this.content.noteIds?.[this.utteranceIndex] || [];
      const currentNoteIds = noteIds.filter((item) => item !== id);

      window.storyteller.updateAssignContent({
        $id: this.content.$id,
        $kind: this.content.$kind,
        ...{
          noteIds: {
            ...this.content.noteIds,
            ...{
              [this.utteranceIndex]: currentNoteIds
            }
          },
          // 更新不触发loading
          touchLoading: false,
          // 清除笔记中标记
          takingNotes: -1
        }
      });
      this.getContent();
      this.$Message.success({
        time: 1500,
        content: '删除成功'
      });
    } catch (error) {
      this.$Message.error({
        time: 1500,
        content: '请求貌似出了些问题，可以重新尝试'
      });
      console.log(error);
    }
  }
}
</script>
<style scoped>
.edit {
  @apply flex resize min-h-60 min-w-60 flex-col fixed w-5/6 h-120 md:w-120 md:h-120 max-w-full max-h-full rounded-md overflow-hidden bg-white;
  z-index: 1;
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.1);
}

.title {
  flex: 0 0 2rem;
}

.title-text {
  color: #3f3356;
}

.title::after {
  @apply absolute -bottom-px left-1/2 h-px mx-auto;
  width: 96%;
  background-color: rgba(236, 233, 241, 1);
  transform: translateX(-50%);
  content: ' ';
}

.note-title {
  @apply text-lg font-semibold mb-2 mt-4;
  color: #3f3356;
}

.note-content {
  color: #3f3356;
}

.textarea {
  @apply p-4 pb-0 ring-0 border-none resize-none;
  background: #f6f7fc;
  border-radius: 5px;
}

.textarea-wrapper {
  @apply overflow-hidden;
  background: #f6f7fc;
  border-radius: 5px;
}

.action-wrapper {
  @apply mb-2;
  flex: 0 0 2rem;
}

.confirm-button {
  @apply bg-motif;
}

.del {
  flex: 0 0 3rem;
  text-align: end;
  transition: all 0.5s;
  @apply text-sm text-blue-500;
}

.notes:hover .del {
  @apply opacity-100;
}

.close {
  flex: 0 0 1rem;
}

.note-icon {
  @apply w-6;
  -webkit-user-drag: none;
}
</style>
